// extracted by mini-css-extract-plugin
export default {"active":"active__f1fC-","main_logo":"main_logo__2o0sE","info_section":"info_section__14GML"};